import request from "../web-sh/src/utils/request";
import global from "../config/global";

async function get_user_chatwoot(params = {}) {
  return request({
    url: global.endpoint.USERS_ME_CHATWOOT,
    method: "get",
    params
  });
}

export default {
  get_user_chatwoot,
};
